import axios from 'axios';
import fileDownload from 'js-file-download';
import { token } from '../stores/user';
let bearer = '';
token.subscribe((newToken) => bearer = newToken);
export function getAuthenticatedData(route) {
    return axios.get(route, {
        headers: { Authorization: `Bearer ${bearer}` }
    });
}
export function downloadAuthenticatedFile(route, fileName) {
    axios.get(route, {
        headers: { Authorization: `Bearer ${bearer}` },
        responseType: 'blob'
    }).then((response) => {
        fileDownload(response.data, fileName);
    });
}
export function postAuthenticatedData(route, data) {
    return axios.post(route, data, {
        headers: { Authorization: `Bearer ${bearer}` }
    });
}
